
export const SORT_OPTIONS = ["best_match", "most_popular", "newest"];

export const ORIENTATION_OPTIONS = ["horizontal", "vertical", "square", "panoramic_horizontal", "panoramic_vertical"];

export const NUMBER_OF_PEOPLE_OPTIONS = ["none", "one", "two", "group"];

export const LICENSE_TYPE_OPTIONS = ["all", "creative", "editorial"];

export const COLOR_OPTIONS = [
	"#E72525",
	"#F48700",
	"#ECA71D",
	"#F1F129",
	"#A9E418",
	"#06D506",
	"#1AE0E0",
	"#0BBBF5",
	"#00F",
	"#7F00FF",
	"#BF00FF",
	"#EA06B1",
	"#000000",
	"#FFFFFF",
];

export const AGE_OPTIONS = ["baby", "child", "teenager", "young_adult", "adult", "adults_only", "mature_adult", "senior_adult"];

export const ETHNICITY_OPTIONS = [
	"black",
	"caucasian",
	"east_asian",
	"hispanic_latino",
	"middle_eastern",
	"mixed_race_person",
	"multiethnic_group",
	"native_american_first_nations",
	"pacific_islander",
	"south_asian",
	"southeast_asian",
];

export const RESOLUTION_OPTIONS = [
	"4k",
	"hd",
];

export const DURATION_MIN = 0;
export const DURATION_MAX = 120;
export const DURATION_STEP = 1;
export const DURATION_INITIAL_VALUE = [DURATION_MIN, DURATION_MAX];
